<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import colors from '@/utils/colors.js';
import { getOptimizedImageSrc } from '@/directives/optimizedImageSize';
import ModuleBadge from '@/components/shared/ModuleBadge.vue';
import { getModuleData } from '@/utils/modules';

const route = useRoute();

const props = defineProps({
  imageUrl: {
    type: String,
    default: '',
  },
});

const moduleColor = computed(() => {
  return route?.meta?.color;
});

const wrapperClass = computed(() => {
  return `bg-${moduleColor.value}`;
});

const optimizedImagedImageUrl = computed(() => {
  return getOptimizedImageSrc(props.imageUrl, 'large');
});

const moduleInfo = computed(() => {
  const moduleData = getModuleData();
  const moduleName = Object.keys(moduleData).find(
    (key) => moduleData[key].entryRouterName === route.name
  );

  if (!moduleName || !moduleData[moduleName]) return undefined;

  const moduleInfo = moduleData[moduleName];

  return {
    key: moduleName,
    icon: moduleInfo.icon,
    color: moduleInfo.colorId,
    name: moduleName,
  };
});

onMounted(() => {
  const selector = document.querySelector('.route-wrapper');
  selector.scrollTop = 400;
});
</script>

<template>
  <div class="coverView w-full h-full" :class="wrapperClass">
    <div
      :style="{
        backgroundImage: `url(${optimizedImagedImageUrl})`,
        backgroundColor: !optimizedImagedImageUrl.length
          ? colors[moduleColor.value]
          : 'none',
        height: '800px',
        opacity: !optimizedImagedImageUrl.length ? '0.9' : '1',
      }"
      class="backgroundWrap z-10 bg-center bg-no-repeat bg-cover bg-inherit fixed w-full animate__animated animate__fadeIn animate__delay-1s animate__fast"
    />

    <div
      class="viewContent w-full animate__animated animate__slideInUp animate__fast z-20 flex flex-col"
      :style="{ marginTop: '40vh' }"
    >
      <slot />

      <ModuleBadge
        v-if="moduleInfo"
        :icon="moduleInfo.icon"
        :color="moduleInfo.color"
        :name="$t(`moduleNames.${moduleInfo.key}`)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.animationStarting .viewContent {
  margin-top: 100vh;
}
.backgroundWrap {
  opacity: 1;
}
.viewContent {
  color: #323232;
  min-height: 1500px;
  position: absolute;

  > :first-child {
    border-radius: 25px 25px 0 0;
    background: #f3f3f3;
    min-height: 1500px;
    padding: 80px 120px;
  }
}
</style>
